import { render, staticRenderFns } from "./ActivityVote.vue?vue&type=template&id=847c2d36&"
import script from "./ActivityVote.vue?vue&type=script&lang=js&"
export * from "./ActivityVote.vue?vue&type=script&lang=js&"
import style0 from "./ActivityVote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports